import useInbox from "hooks/useInbox.ts";

const useInboxQueryParams = () => {
  const { setSearchParams } = useInbox();

  const getQueryParam = (param: string): string | null => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
  };

  const setQueryParams = (params: { [key: string]: string }): void => {
    setSearchParams(params);
    const searchParams = new URLSearchParams(window.location.search);
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    });

    if (!params.pn) {
      searchParams.set("pn", "1");
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  const setQueryParamsAndRemoveManageStorage = (params: {
    [key: string]: string;
  }): void => {
    setSearchParams(params);
    const searchParams = new URLSearchParams(window.location.search);
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    });
    const pathnameWithoutManageStorage = window.location.pathname.replace(
      "/manageStorage",
      ""
    );

    const newUrl = `${pathnameWithoutManageStorage}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  const removeQueryParam = (param: string | string[]): void => {
    const searchParams = new URLSearchParams(window.location.search);
    if (typeof param === "string") {
      searchParams.delete(param);
    } else {
      param.forEach((p) => {
        searchParams.delete(p);
      });
    }
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  return {
    getQueryParam,
    setQueryParams,
    removeQueryParam,
    setQueryParamsAndRemoveManageStorage,
  };
};

export default useInboxQueryParams;
